import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { fetchJSONUnsafe } from '../../utils/fetchJSON.js';
import { formatDate } from '../../utils/formatDate.js';
const DEPOSITARY_URL = '/api/v1/depository';
export const useDepository = ({ size, page, query, startDate, endDate }) => {
    const formatStartDate = startDate ? formatDate(startDate, true) : '';
    const formatEndDate = endDate ? formatDate(endDate, true) : '';
    const searchParams = new URLSearchParams(DEPOSITARY_URL);
    searchParams.set('page', String(page));
    searchParams.set('size', String(size));
    searchParams.set('query', query);
    searchParams.set('timestampStart', formatStartDate);
    searchParams.set('timestampEnd', formatEndDate);
    const queryString = `?${searchParams.toString()}`;
    const { data } = useAsyncData(DEPOSITARY_URL + queryString, fetchJSONUnsafe);
    return { items: data?.content, totalPages: data?.totalPages };
};
//# sourceMappingURL=useDepository.js.map